<template>
<div class="container-fluid bg-default-color">
	<equipment-toolbar heading="Fleet Tracking">

		<equipment-list-nav-tabs></equipment-list-nav-tabs>

	</equipment-toolbar>

	<div>
		<vue-map
			:center="{
				lat: +$store.company.lat,
				lng: +$store.company.long
			}"
			:zoom="9"
			:markers="equipmentMarkers"
			map-size="map-lg">
		</vue-map>
		
		<table-list record-name="Equipment"
			:fields="[
				{label: 'Equipment',key: 'equipmentDescription', type: 'link'},
				{label: 'Type',key: 'equipmentType'},
				{label: 'Status',key: 'status'},
				{label: 'Assigned To', key: 'userAssignedTo'},
				{label: 'Clocked Into', key: 'userClockedInto'},
				{label: 'Speed',key: 'speedKm'},
				{label: 'Fuel Level',key: 'fuelLevel'},
			]"
			:records="mutatedFleetGeo"
			has-edit="/equipment/item/{?}/location"
			edit-button-text="View"
			id-field="slug">
		</table-list>
	</div>

</div>
</template>
<script type="text/javascript">
import EquipmentToolbar from "./EquipmentToolbar"	
import VueMap from "@/components/VueMap"
import TableList from "@/components/TableList"
import EquipmentListNavTabs from "./EquipmentListNavTabs"


export default {
	name: "EquipmentGeoTracking",
	components: {
		EquipmentToolbar,
		EquipmentListNavTabs,
		VueMap,
		TableList
	},
	data() {
		return {
			fleetGeo: [],
			dispatchedServices: [],
			activeProjects: []
		}
	},
	computed: {
		equipmentMarkers() {
			return this.fleetGeo.map(item => {

				let infoWindowText = "<strong>" + item.Equipment.description + "</strong> &nbsp; &nbsp; <br> "

				if (item.isDriving) {
					infoWindowText += "Speed: " + item.speed + " km/h"
				}
				else {


					infoWindowText += "Stationary for last " + item.currentStateDuration + " &nbsp; &nbsp; "
				}

				return {
					lat: +item.latitude,
					lng: +item.longitude,
					icon: window.apiRoot+"resources/icons/truck_36.png",
					infoWindowText
				}
			})
		},
		mutatedFleetGeo() {
			let vm = this
			return this.fleetGeo.map(item => {
				item.equipmentDescription = {
					text: item.Equipment.description,
					link: "/equipment/item/" + item.Equipment.slug + "/location"
				}

				item.equipmentType = item.Equipment.EquipmentType.name

				item.speedKm = item.speed + " km/h"

				item.status = "Stopped"
				if (item.isDriving)
					item.status = "Driving"

				//find nearest job and service
				let nearestProject = false
				let nearestProjectDistance = 100000000
				vm.$store.projects.forEach(job => {
					let distance = vm.getDistance(job.lat,job.long,item.latitude, item.longitude)

					if (distance < nearestProjectDistance) {
						nearestProject = job
						nearestProjectDistance = distance
					}
				})

				if (nearestProjectDistance < nearestProject.check_in_tolerance)
					item.status = "Onsite at <a href='/project/" + nearestProject.slug + "/dashboard' target='_blank'>Project #" + nearestProject.job_num + "</a>"

				let nearestService = false
				let nearestServiceDistance = 100000000
				vm.$store.services.forEach(job => {
					let distance = vm.getDistance(job.lat,job.long,item.latitude, item.longitude)

					if (distance < nearestServiceDistance) {
						nearestService = job
						nearestServiceDistance = distance
					}
				})


				console.log(item.equipmentDescription, nearestService.job_num, nearestServiceDistance)

				if (nearestServiceDistance < nearestService.check_in_tolerance)
					item.status = "Onsite at <a href='/service/" + nearestService.slug + "/dashboard' target='_blank'>Service #" + nearestService.job_num + "</a>"

				item.fuelLevel = ""
				if ("StatusData" in item && item.StatusData && "DiagnosticFuelLevelId" in item.StatusData && item.StatusData.DiagnosticFuelLevelId)
					item.fuelLevel = Math.round(item.StatusData.DiagnosticFuelLevelId) + "%"

				/*
				item.nearestProject = nearestProject.job_num + " (" + nearestProjectDistance.toFixed(0) + "m)"
				item.nearestService = nearestService.job_num + " (" + nearestServiceDistance.toFixed(0) + "m)"
				*/

				return item
			})
		}
	},
	methods: {
		fetchEquipmentWithTracking() {
			let vm = this

			let params = {
				filters: [
					["geotab_entity_id !=",""]
				],
				include: [
					"User"
				]
			}

			this.getJSON("Equipment/get",params).then(response => {
				if (response.success)
					vm.equipmentItemsWithTracking = response.data
			})
		},
		fetchFleetGeo() {
			let vm = this

			this.getJSON("Equipment/get-fleet-geo-data").then(response => {
				if (response.success)
					vm.fleetGeo = response.data
			})
		}
	},
	created() {
		this.fetchEquipmentWithTracking()
		this.fetchFleetGeo()
		this.fetchJobs(false,false,["id","slug","lat","long","job_num","job_name","check_in_tolerance"])
		this.fetchServices(false,[["status","Dispatched"]],["id","slug","lat","long","job_num","job_name","check_in_tolerance"])
	}
}
</script>